package com.neurobs.ccabserver.subjectsessionview.components.sessionrunview

import com.neurobs.ccabserver.subjectsessionview.components.sessionrunview.components.{LogTestRunTestRunView, LogTestRunView, TestRunView}
import com.neurobs.ccabserver.subjectsessionview.states.RunSelectionStateGenerator
import com.neurobs.react.semanticui.{UiContainerFactory, UiMessageFactory}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

@react
object SessionRunView {
  case class Props()
  val component = FunctionalComponent[Props] { _ =>

    val runSelectionState = RunSelectionStateGenerator.accessState

    def enclosingSegment (elements: ReactElement*) = {
      UiContainerFactory.Segment(
        elements
      )("blue raised")
    }

    runSelectionState.selectedRunState.value match {
      case None => null
      case Some(run) =>
        run.logTestRun match {
          case None => run.testRun match {
            case None => UiMessageFactory.BasicMessage("No data is present for this test run.")
            case Some(testRun) =>
              TestRunView(testRun, enclosingSegment(_))
          }
          case Some(logTestRun) =>
            run.testRun match {
              case None => LogTestRunView(logTestRun, enclosingSegment(_))
              case Some(testRun) => LogTestRunTestRunView(logTestRun, testRun, enclosingSegment(_))
            }
        }
    }
  }
}




